// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__7edjN","label":"SetPasswdForm_label__3-ku_"};